var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("插槽")]),_c('Layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("开课吧全栈")]},proxy:true},{key:"footer",fn:function({fc}){return [_vm._v(_vm._s(fc))]}}])},[[_vm._v("content...")]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }